export const identityDesignTokens = Object.freeze({
  background: "#050505",
  surface: "#0c0c0c",
  textPrimary: "#ffffff",
  textSecondary: "rgba(255,255,255,.68)",
  neutralLine: "rgba(255,255,255,.16)",
  subtleLine: "rgba(255,255,255,.08)",
  gridOpacity: .05,
  accentOpacitySoft: .28,
  accentOpacityMedium: .58,
  diagonalAngle: -18,
  lineWidthThin: 1,
  lineWidthMedium: 2,
  radiusSmall: 10,
  radiusMedium: 18,
  clippedCorner: .12,
  shadow: "0 18px 50px rgba(0,0,0,.45)",
  textureStrength: .075,
  logoSafeZone: .06,
  qrSafeZone: .035,
  transition: "200ms"
});

// Shared proportions power both React previews and canvas exports. Product
// renderers still own their content layout and physical silhouette.
export const identityProductLanguage = Object.freeze({
  card: Object.freeze({ spine: "compact", grid: "restrained", panel: "outline", lines: "diagonal", corners: "bracket", qrFrame: "compact", edge: "subtle" }),
  mirror: Object.freeze({ spine: "tall", grid: "technical", panel: "stepped", lines: "telemetry", corners: "strong", qrFrame: "high-visibility", edge: "keyline" }),
  sticker: Object.freeze({ spine: "bold", grid: "restrained", panel: "filled", lines: "speed", corners: "notched", qrFrame: "standard", edge: "cut" }),
  qr: Object.freeze({ spine: "hidden", grid: "hidden", panel: "hidden", lines: "hidden", corners: "hidden", qrFrame: "none", edge: "none" })
});

export const identityBaseThemes = Object.freeze({
  dark: Object.freeze({ background: "#050505", surface: "#0c0c0c", textPrimary: "#ffffff", textSecondary: "rgba(255,255,255,.68)", neutralLine: "rgba(255,255,255,.16)", subtleLine: "rgba(255,255,255,.08)", gridOpacity: .05, edge: "rgba(255,255,255,.25)" }),
  light: Object.freeze({ background: "#ffffff", surface: "#ffffff", textPrimary: "#101010", textSecondary: "rgba(0,0,0,.62)", neutralLine: "rgba(0,0,0,.12)", subtleLine: "rgba(0,0,0,.07)", gridOpacity: .04, edge: "rgba(0,0,0,.22)" })
});

export function identityCssVariables(accentColor, baseTheme = "dark") {
  const theme = identityBaseThemes[baseTheme] || identityBaseThemes.dark;
  return {
    "--identity-accent": accentColor,
    "--identity-bg": theme.background,
    "--identity-surface": theme.surface,
    "--identity-text": theme.textPrimary,
    "--identity-text-secondary": theme.textSecondary,
    "--identity-neutral-line": theme.neutralLine,
    "--identity-subtle-line": theme.subtleLine,
    "--identity-grid-opacity": theme.gridOpacity,
    "--identity-edge": theme.edge,
    "--identity-angle": `${identityDesignTokens.diagonalAngle}deg`
  };
}
